require('jqmask');

$(() => {
  $("[data-id='zip']").mask('9999', { placeholder: '' });
});



// WEBPACK FOOTER //
// ./js/countryForm/norway.form.js